/**
 * Convert string into trimmed string.
 * @memberof module:stringcase/lib
 * @function trimcase
 * @param {string} str - String to convert.
 * @returns {string} Trimmed case string.
 */
'use strict';
/** @lends trimcase */

function trimcase(str) {
  return String(str).trim();
}

module.exports = trimcase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRyaW1jYXNlLmpzIl0sIm5hbWVzIjpbInRyaW1jYXNlIiwic3RyIiwiU3RyaW5nIiwidHJpbSIsIm1vZHVsZSIsImV4cG9ydHMiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7O0FBUUE7QUFFQTs7QUFDQSxTQUFTQSxRQUFULENBQW1CQyxHQUFuQixFQUF3QjtBQUN0QixTQUFPQyxNQUFNLENBQUNELEdBQUQsQ0FBTixDQUFZRSxJQUFaLEVBQVA7QUFDRDs7QUFFREMsTUFBTSxDQUFDQyxPQUFQLEdBQWlCTCxRQUFqQiIsInNvdXJjZVJvb3QiOiIuLi8uLi9saWIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvbnZlcnQgc3RyaW5nIGludG8gdHJpbW1lZCBzdHJpbmcuXG4gKiBAbWVtYmVyb2YgbW9kdWxlOnN0cmluZ2Nhc2UvbGliXG4gKiBAZnVuY3Rpb24gdHJpbWNhc2VcbiAqIEBwYXJhbSB7c3RyaW5nfSBzdHIgLSBTdHJpbmcgdG8gY29udmVydC5cbiAqIEByZXR1cm5zIHtzdHJpbmd9IFRyaW1tZWQgY2FzZSBzdHJpbmcuXG4gKi9cblxuJ3VzZSBzdHJpY3QnXG5cbi8qKiBAbGVuZHMgdHJpbWNhc2UgKi9cbmZ1bmN0aW9uIHRyaW1jYXNlIChzdHIpIHtcbiAgcmV0dXJuIFN0cmluZyhzdHIpLnRyaW0oKVxufVxuXG5tb2R1bGUuZXhwb3J0cyA9IHRyaW1jYXNlOyJdfQ==